import { SiteContent } from "./types"

export const defaultContentFr: SiteContent = {
  hero: {
    title: "CONFIEZ-NOUS VOTRE BIEN IMMOBILIER",
    description:
      "OBELISK — une entreprise spécialisée dans les rénovations clé en main. Nous prenons en charge le cycle complet des travaux — de la conception à la livraison du bien rénové. On nous fait confiance en Ukraine et à l'étranger. Aujourd'hui, nous proposons nos services de rénovation clé en main en France — notamment à Paris.",
    bullets: [
      "délais d'exécution respectés",
      "collaboration avec des designers et ingénieurs",
      "prise en compte des contraintes techniques réelles",
      "artisans vérifiés et qualifiés",
      "garantie sur les travaux réalisés",
    ],
  },
  stats: [
    { id: 1, value: 150, suffix: "+", description: "projets réalisés" },
    { id: 2, value: 7, suffix: "", description: "ans sur le marché" },
    { id: 3, value: 200, suffix: "+", description: "clients satisfaits" },
    { id: 4, value: 5, suffix: " ans", description: "de garantie" },
  ],
  advantages: {
    sectionTitle: "Choisissez OBELISK, car nous :",
    items: [
      {
        id: 1,
        title: "Réalisons des projets complexes et atypiques",
        description:
          "Nous prenons en charge les tâches les plus complexes et non standard que d'autres n'osent pas réaliser",
      },
      {
        id: 2,
        title: "Planifions les travaux clairement et par étapes",
        description:
          "Planification détaillée de chaque étape avec un calendrier transparent d'exécution des travaux",
      },
      {
        id: 3,
        title: "Approche individuelle et complète sans chaos",
        description:
          "Approche personnalisée pour chaque client en tenant compte de tous les souhaits et spécificités",
      },
      {
        id: 4,
        title: "Respectons strictement les délais convenus",
        description:
          "Nous terminons les travaux exactement dans les délais convenus, sans retards ni reports",
      },
      {
        id: 5,
        title: "Contrôlons et garantissons la qualité",
        description:
          "Contrôle qualité multi-niveaux à chaque étape avec une garantie allant jusqu'à 5 ans",
      },
      {
        id: 6,
        title: "Associons fonctionnalité et esthétique",
        description:
          "Nous créons des espaces à la fois beaux et parfaitement fonctionnels",
      },
      {
        id: 7,
        title: "Économisons votre temps et votre budget",
        description:
          "Optimisation des coûts sans perte de qualité, travail efficace et économique",
      },
      {
        id: 8,
        title: "Concrétisons vos rêves de confort",
        description:
          "Nous créons un espace dans lequel vous vous sentirez heureux et à l'aise",
      },
    ],
  },
  services: {
    sectionTitle: "Rêvez — tout le reste est inclus dans nos services :",
    items: [
      {
        id: 1,
        title: "Visite du chantier et consultation",
        description:
          "Nous évaluons l'état du local, calculons le coût et la portée des travaux, fixons les délais de livraison",
      },
      {
        id: 2,
        title: "Achat et logistique des matériaux",
        description:
          "Nous sélectionnons les matériaux les plus qualitatifs selon les besoins du client et les livrons sur place",
      },
      {
        id: 3,
        title: "Travaux de démolition",
        description:
          "Démolition des murs et cloisons, enlèvement des anciens revêtements (carrelage, parquet, papier peint, peinture, plâtre), évacuation des gravats",
      },
      {
        id: 4,
        title: "Travaux de gros œuvre",
        description:
          "Nivellement des murs et plafonds, chape de sol, pose de plaques de plâtre et niches",
      },
      {
        id: 5,
        title: "Installation des réseaux techniques",
        description:
          "Travaux de plomberie, installation électrique, chauffage, ventilation, climatisation",
      },
      {
        id: 6,
        title: "Travaux de finition",
        description:
          "Application d'enduit, lissage, peinture ou pose de papier peint ou revêtements décoratifs, carrelage, stratifié ou parquet",
      },
      {
        id: 7,
        title: "Travaux de montage",
        description:
          "Pose de portes, montage de la plomberie, éclairage, installation de mobilier",
      },
      {
        id: 8,
        title: "Nettoyage et remise du chantier",
        description:
          "Nous faisons appel au service de nettoyage, vous remettons les clés et nous réjouissons avec vous",
      },
    ],
  },
  faq: {
    sectionTitle: "Questions fréquentes sur la rénovation",
    items: [
      {
        id: 1,
        question: "Quelle garantie est fournie pour la rénovation ?",
        answer:
          "À condition que nous achetions les matériaux et intervenions à toutes les étapes de la rénovation du début à la fin, la garantie sur les travaux de plomberie et d'installation électrique est de 5 ans.",
      },
      {
        id: 2,
        question: "De quoi dépend le coût de la rénovation ?",
        answer:
          "Le coût de la rénovation dépend du contenu, de la superficie et du coût des matériaux de finition choisis et payés séparément par le client.",
      },
      {
        id: 3,
        question: "Le coût des matériaux est-il inclus dans le prix ?",
        answer:
          "Oui, les matériaux bruts et de finition sont inclus dans le coût de la rénovation.",
      },
      {
        id: 4,
        question: "Qui achète les matériaux ?",
        answer:
          "En règle générale, lors d'une rénovation clé en main, nous achetons tous les matériaux. Nous testons les marques, fabricants et fournisseurs depuis des années pour garantir la qualité et la durabilité.",
      },
      {
        id: 5,
        question: "Combien de temps dure la rénovation ?",
        answer:
          "De 4 à 12 mois, selon la superficie et la complexité des travaux.",
      },
      {
        id: 6,
        question: "Que faire si la rénovation est endommagée par la faute des voisins ?",
        answer:
          "Dans ce cas, nous recommandons d'établir des documents officiels, notamment des procès-verbaux de travaux. Ceux-ci attestent que les travaux ont été effectués et les services fournis en totalité et conformément aux termes du contrat.",
      },
      {
        id: 7,
        question: "Que faire si quelque chose ne convient pas après les travaux ?",
        answer:
          "S'il y a des défauts visibles, signalez-les immédiatement — nous les corrigerons rapidement. Tous les autres souhaits doivent être discutés avant le début de chaque étape pour éviter tout désagrément.",
      },
    ],
  },
  pricing: [
    {
      id: "pricing-basic",
      price: "700–850$",
      title: "Rénovation de base",
      features: [
        "Travaux de plomberie et d'installation électrique",
        "Murs — enduit de plâtre, puis finition pour peinture lavable",
        "Fenêtres — isolation des ébrasements",
        "Carrelage — format moyen, travaux de pose",
        "Sol — chauffage électrique au sol dans la salle de bain et le couloir, stratifié résistant à l'usure, plinthe en plastique",
        "Plafond — tendu, luminaires en saillie",
        "Portes — panneau creux en aggloméré/contreplaqué, quincaillerie de qualité",
        "Meubles — MDF",
      ],
    },
    {
      id: "pricing-standard",
      price: "950–1 100$",
      title: "Rénovation standard",
      features: [
        "Travaux de plomberie et d'installation électrique, commande à distance du chauffage",
        "Murs — enduit de plâtre, finition pour peinture, protection supplémentaire contre les grandes fissures",
        "Fenêtres — isolation des ébrasements",
        "Carrelage — format moyen et petit, travaux de pose",
        "Sol — chauffage au sol dans la salle de bain, couloir, cuisine (électrique, hydraulique ou combiné), isolation partielle ou complète, revêtement vinyle, stratifié, plinthes MDF",
        "Plafond — plaques de plâtre, combinaison de spots encastrés et en saillie, systèmes de rails",
        "Portes — cadre en pin ou MDF, quincaillerie de qualité",
        "Meubles — MDF plaqué",
      ],
    },
    {
      id: "pricing-premium",
      price: "1 500–1 700$",
      title: "Rénovation premium",
      features: [
        "Travaux d'installation électrique et de plomberie, commande à distance du chauffage dans chaque pièce",
        "Murs — enduit de plâtre, finition pour peinture résistante à l'usure à effet antibactérien, protection totale contre les fissures de toute origine",
        "Portes et fenêtres — bois massif : chêne, frêne, pin ; portes à montage caché, isolation des ébrasements",
        "Carrelage — petit et grand format, travaux de pose",
        "Sol — chauffage hydraulique au sol, isolation sur toute la superficie, parquet en bois, plinthe en bois ou métal",
        "Plafond — plaques de plâtre, isolation acoustique, profilé en retrait avec éclairage LED, spots encastrés en plâtre ou autre variante de votre choix",
        "Meubles — bois massif",
        "Réalisation de solutions de design individuelles de toute complexité",
      ],
    },
  ],
  contacts: {
    phone: "+38 063 664 41 32",
    phoneHref: "tel:+380636644132",
    email: "obelisk79011@gmail.com",
    emailHref: "mailto:obelisk79011@gmail.com",
    address: "Lviv, rue I. Franka 45",
    mapHref: "https://maps.app.goo.gl/mH3oEa8JCmG7QyQH9",
    workHours: "Lun–Sam : 10:00 – 17:00",
  },
  reviews: [
    {
      id: 1,
      author: "Artem Flood",
      rating: 5,
      text: "Дуже довго шукали бригаду, якій можна довіряти ремонт квартири, і не пожалкували, що зупинились на Obelisk! Все було прозоро від першого дзвінка до фінального прибирання — кошторис без сюрпризів, постійний зв'язок, відповіді на всі питання. Майстри реально розуміються на своїй справі: підказали по матеріалах, врахували наші побажання по дизайну. Квартира вийшла саме такою, як ми хотіли. Рекомендую всім, хто цінує якість і чесність!",
      date: "Juin 2025",
    },
    {
      id: 2,
      author: "Юра Спондич",
      rating: 5,
      text: "",
      date: "Juin 2025",
    },
  ],
}
